import './dcvegan/style';
import FormStructure from './dcvegan/form_structure';

export default FormStructure;